import { LuSearch } from "react-icons/lu";
import "./SearchInput.scss";

/**
 * Controlled search field with icon for Plan Manager list toolbars.
 *
 * @param {object} props
 * @param {string} props.value - Current search text.
 * @param {(value: string) => void} props.onChange - Emits new search text.
 * @param {string} props.placeholder - Input placeholder.
 * @param {string} props.ariaLabel - Accessible label for the input.
 * @param {boolean} [props.disabled=false] - Disables the input when true.
 * @returns {import('react').JSX.Element}
 */
const SearchInput = ({
    value,
    onChange,
    placeholder,
    ariaLabel,
    disabled = false,
}) => (
    <div className="plan-manager-search-input">
        <LuSearch
            className="plan-manager-search-input__icon"
            aria-hidden
            size={16}
        />
        <input
            type="text"
            className="plan-manager-search-input__field"
            placeholder={placeholder}
            aria-label={ariaLabel}
            value={value}
            disabled={disabled}
            onChange={(event) => onChange(event.target.value)}
        />
    </div>
);

export default SearchInput;
